import { TabContext, TabPanel } from '@mui/lab';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Tab, Tabs } from '@mui/material';
import { SettingsTabType, ViewerSettingsTabType } from 'constants/settings.constants';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { Fragment, useEffect, useState } from 'react';
import { selectLanguage, selectTranslations } from 'state/reducers/translation.reducers';
import { HeaderPage1 } from 'theme/elements/Headers';
import { Page } from 'theme/elements/Page';
import BankAccounts from 'sections/settings/bankAccounts';
import { CustomTabs } from 'theme/elements/Tabs';
import MyProfile from 'sections/settings/ProfileSettings/MyProfile';
import { setMessage } from 'state/reducers/settings.reducers';
import FundsWithdrawal from 'sections/settings/FundsWithdrawal';
import Contacts from 'sections/settings/Contacts/Contacts';
import { UserPermission } from 'constants/user.constants';
import { getUserDetails, getUserPermission } from 'state/reducers/user.reducers';
import { getMobile } from 'state/reducers/ui.reducers';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChangePlan from 'sections/settings/plans/index';
import { useParams } from 'react-router-dom';
import ChangeCreditCard from 'sections/settings/CreditCard';
import { getCompanyName } from 'utils';
import { getContactsByCompanyId } from 'services/contact.services';
import { getBankAccountsByCompanyId } from 'services/bank-account.services';
import { getBalancesByCompanyId } from 'services/balance.services';
import { getBalancesActivityByCompanyId } from 'services/activity.services';

export const SettingsTabComponents = {
  BankAccounts: <BankAccounts />,
  MyProfile: <MyProfile />,
  FundsWithdrawal: <FundsWithdrawal />,
  Contacts: <Contacts />,
  // ChangePlan: <ChangePlan />,
  // CreditCard: <ChangeCreditCard />,
};

export default function SettingsApp() {
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);
  const { companyName, companyHebrewName, companyBankAccount, companyId } = useAppSelector(getUserDetails);
  const userPermission = useAppSelector(getUserPermission);
  const isMobile = useAppSelector(getMobile);
  const [currentTabIdx, setCurrentTabIdx] = useState<string>('0');
  const tabs = _.includes([UserPermission.OPERATIONER, UserPermission.SIGNER], userPermission)
    ? SettingsTabType
    : ViewerSettingsTabType;
  const { type } = useParams();
  const selectedLang = useAppSelector(selectLanguage);

  useEffect(() => {
    dispatch(setMessage({ exist: false }));
    dispatch(getContactsByCompanyId());
    dispatch(getBankAccountsByCompanyId())
    dispatch(getBalancesByCompanyId())
    dispatch(getBalancesActivityByCompanyId(Number(companyId)));
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, val: number) => {
    dispatch(setMessage({ exist: false }));
    setCurrentTabIdx(String(val));
  };

  return (
    <Page>
      <Fragment>
        <Stack spacing={{ sm: 1, xs: 2 }} sx={{ position: 'relative', height: '100%' }}>
          <HeaderPage1
            title={getCompanyName(companyHebrewName, companyName, selectedLang)}
            text={companyBankAccount}
          />
          {!isMobile ? (
            <TabContext value={currentTabIdx}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <CustomTabs>
                  <Tabs value={+currentTabIdx} onChange={handleTabChange}>
                    {_.values(tabs).map((val, idx) => (
                      <Tab
                        key={val}
                        id={val}
                        tabIndex={idx}
                        label={t(`page.settings.tab.${_.snakeCase(val)}.title`)}
                      />
                    ))}
                  </Tabs>
                </CustomTabs>
              </Box>
              {_.values(tabs).map((val, idx) => (
                <TabPanel key={val} value={'' + idx}>
                  {/* {val} */}
                  {SettingsTabComponents[val]}
                </TabPanel>
              ))}
            </TabContext>
          ) : (
            <CustomTabs>
              {' '}
              {/* {mobile view} */}
              {_.values(tabs).map((val, idx) => (
                <Accordion key={idx} defaultExpanded={type === val}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    {t(`page.settings.tab.${_.snakeCase(val)}.title`)}
                  </AccordionSummary>
                  <AccordionDetails>{SettingsTabComponents[val]}</AccordionDetails>
                </Accordion>
              ))}
            </CustomTabs>
          )}
        </Stack>
      </Fragment>
    </Page>
  );
}
